// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"60bca9ab","703":"04c06afb"}[chunkId] + ".chunk.js";
};